var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEchEmptyContainerHandler = function SvgEchEmptyContainerHandler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3 100.7c4.7 0 8.5-3.8 8.5-8.5s-3.8-8.5-8.5-8.5-8.5 3.8-8.5 8.5c.1 4.7 3.9 8.5 8.5 8.5ZM95.2 100.7c4.7 0 8.5-3.8 8.5-8.5s-3.8-8.5-8.5-8.5-8.5 3.8-8.5 8.5 3.8 8.5 8.5 8.5Z",
    stroke: "#2C112D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.5 78H86.7l-8.5 14.1H44.3L35.8 78H13.2M106.5 78l-2.3-9.2c-.3-1.3-1.4-2.1-2.7-2.1H81.1L78.3 78H35.8",
    stroke: "#2C112D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m47.1 78 25.5-25.5h28.3M13.2 13v82",
    stroke: "#2C112D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2 52.6h-8.5v14.1h8.5V52.6ZM7.5 49.8V21.5M78.3 52.6l5-15c.4-1.2 1.5-1.9 2.7-1.9h6.4c1.6 0 2.8 1.3 2.8 2.8v14.1M13.2 44.1 78.3 78",
    stroke: "#2C112D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgEchEmptyContainerHandler;